import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m593-459-57-57 173-219H317l-79-80h534q31 0 44 27t-6 51L593-459Zm-18 161v98q0 23-16 38-16 16-39 16h-80q-23 0-38-16-16-15-16-38v-286L66-806q-10-10-10-24-1-14 10-24 10-10 23-10 14 0 24 10l740 740q10 10 10 23 1 14-9 24t-24 10q-14 0-24-10L575-298Zm-39-218Z"/>',
  f: '<path d="M593-459 238-815h534q31 0 44 27t-6 51L593-459Zm-18 161v98q0 23-16 38-16 16-39 16h-80q-23 0-38-16-16-15-16-38v-286L66-806q-10-10-10-24-1-14 10-24 10-10 23-10 14 0 24 10l740 740q10 10 10 23 1 14-9 24t-24 10q-14 0-24-10L575-298Z"/>',
};

export default data;
